<template>
  <ion-page :lang="$i18n.locale">
    <ion-content
      :lang="$i18n.locale"
      fullscreen="true"
      class="master"
      :scroll-events="enableScrollEvent"
      @ionScroll="onScroll"
      ><main class="lg:flex">
        <slot class="flex-1 pb-16 lg:pb-0"> </slot>
      </main>
    </ion-content>
  </ion-page>
</template>
<script>
import { IonPage, IonContent} from "@ionic/vue";
export default {
  components: {
    IonPage,
    IonContent,
  },
  props: {
    enableScrollEvent: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onScroll(event) {
      this.$emit("on-scroll", event);
    },
  },
};
</script>
<style scoped></style>
